import React, { useEffect, useState } from "react";
import AddEditForm from "../../AddEditForm";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListDataClient from "./ListDataSector";
import PromptElement from "../../PromptElement";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";

export default function Sector(props) {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [sectorList, setSectorList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [sectorId, setSectorId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [prevName, setPrevName] = useState("");
  const [prevDescription, setPrevDescription] = useState("");

  const token = localStorage.getItem("token");
  const getSectors = () => {
    setLoading({listData:true})
    axios
      .get("/dashboard/sector", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSectorList(res.data.data);
         setLoading({ listData: false });
      })
      .catch((err) => {
        dispatch(setAppError({ msg: err.message }));
        setLoading({ listData: false });
      });
  };
  useEffect(() => {
    getSectors();
  }, []);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = { name, description };

      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/sector`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        if (name === prevName && description === prevDescription) {
          setSubmitFormLoading(false);
          return dispatch(setAppError({ msg: "No changes made." }));
        }
        response = await axios.put(
          `/dashboard/sector/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      getSectors();
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/sector");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "client");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/sector");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id, data) => {
    navigate(`/dashboard/sector/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setSectorId(data.id);
        setName(data.name);
        setDescription(data.description);
        setPrevName(data.name);
        setPrevDescription(data.description);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/sector/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getSectors();
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));

        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setDescription("");
    setName("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const isCreateMode = location.pathname.endsWith("/sector/create");
  const isEditMode = location.pathname.includes("/sector/edit");

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method) {
      setAddOrEdit({});
      navigate("/dashboard/sector");
    } else if (isCreateMode && !checkAccess("Sector", "sector-create")) {
      setAddOrEdit({});
      navigate("/dashboard/sector");
    } else if (isEditMode && !checkAccess("Sector", "sector-edit")) {
      setAddOrEdit({});
      navigate("/dashboard/sector");
    }
  }, []);

  const commonItems = [{ label: "SECTOR", link: "/dashboard/sector" }];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
    ? [...commonItems, { label: "CREATE", link: "/dashboard/sector" }]
    : commonItems;

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            <ListDataClient
              list={sectorList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={loading.listData}
              column={5}
              titles={["S.No.", "SECTOR", "Remarks", "Action"]}
              addData={addData}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditForm
            component="client"
            form={[
              {
                type: "text",
                text: "SECTOR",
                name: "SECTOR",
                value: name,
                update: setName,
                columnName: "name",
                notRequired: true,
              },
              {
                type: "textarea",
                text: "Remarks",
                name: "remarks",
                value: description,
                update: setDescription,
                columnName: "description",
                notRequired: true,
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={
              addOrEdit.method === "edit" && addOrEdit.loadedValues
                ? true
                : false
            }
          />
        )}
      </div>
    </>
  );
}
